import { useAuthStore } from '@/store/auth.store';
import { useQuery } from '@tanstack/react-query';
import { assistantService } from '../services/assistant.service';

/**
 * L'assistant est-il activé sur ce serveur ? Demandé une fois (dix minutes de
 * cache), partagé entre l'en-tête et l'écran. Sans réponse, on ne suppose
 * JAMAIS « disponible » : une porte qui ne mène nulle part n'est pas montrée
 * (verdict QA du 12/09/2026).
 */
export function useAssistantDisponible() {
  const { user, isAuthenticated } = useAuthStore();
  const eligible = isAuthenticated && !!user && user.role !== 'vault_user';
  const requete = useQuery({
    queryKey: ['assistant', 'disponibilite'],
    queryFn: () => assistantService.disponibilite(),
    enabled: eligible,
    staleTime: 10 * 60 * 1000,
    retry: 1,
  });
  const statut = (requete.error as { response?: { status?: number } } | null)
    ?.response?.status;
  return {
    /** true / false quand le serveur a répondu, undefined tant qu'on ne sait pas. */
    disponible: requete.data?.disponible,
    ecriture: requete.data?.ecriture ?? false,
    /** Pourquoi on ne peut pas s'en servir, dans les mots de l'utilisateur. */
    raison: !eligible
      ? 'Cet espace n’est pas accessible depuis un accès coffre.'
      : requete.isError
        ? statut === 403
          ? 'Cet espace n’est pas accessible depuis cet accès.'
          : 'Impossible de joindre l’assistant pour le moment. Rechargez la page.'
        : requete.data && !requete.data.disponible
          ? 'L’assistant n’est pas activé sur ce serveur.'
          : undefined,
    chargement: eligible && requete.isPending,
  };
}
